export default "__VITE_ASSET__BxRj3_Vb__"